import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'

class Stars extends Component {

  render () {
    if (!this.props.count) {
      return null
    }
    return (
      <div className={'Stars Stars-' + this.props.type}>
        <div className="Stars-Inner" style={{ width: (parseFloat(this.props.count) * 100 / 5) + '%' }}></div>
      </div>
    )
  }
}

Stars.propTypes = {
  type: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Stars
